import { Yup } from "components/DynamicForm/utils";
import { COURIERS, DYNAMIC_TYPE_INPUT_TYPE, JSON_TABLE_INPUT_TYPE, SELECT_INPUT_TYPE } from "utils/Constants";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": "text",
                    "name": "secuencia",
                    "disabled": true,
                    "label": "Secuencia",
                    "sizing": {
                        "sm": 4
                    }
                },
                {
                    "type": "text",
                    "name": "warehouseNumber",
                    "label": "Warehouse Number",
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "provedor",
                    "label": "Proveedor"
                },
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "client",
                    "label": "Client"
                },
            ],
            [
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "tracking_num",
                    "label": "Numero Tracking",
                    "sizing": {
                        "sm": 5
                    }
                },
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "courier",
                    "validation": Yup.string().required(),
                    "creatable": true,
                    "label": "Transportista",
                    "options": COURIERS
                },
                {
                    "type": "money",
                    "name": "cost",
                    "validation": Yup.string().required(),
                    "label": "Precio",
                    "isDecimal": true,
                    "step": ".01",
                    "sizing": {
                        "sm": 3
                    }
                },
            ],
            [
                {
                    "type": "country",
                    "name": "origin",
                    "label": "Pais Origen"
                },
                {
                    "type": "text",
                    "name": "puerto_carga",
                    "label": "Puerto Cargar"
                },
                {
                    "type": "country",
                    "name": "destino",
                    "label": "Pais Destino"
                },
                {
                    "type": "text",
                    "name": "puerto_descarga",
                    "label": "Puerto Descarga"
                },
            ],
            [
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "measures",
                    "label": "Medidas",
                    "dynamicType": "text",
                    "options": {
                        "cm": "cm",
                        "in": "inch",
                    },
                    "defaultOption": "cm"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "dynamicType": "number",
                    "name": "weigth",
                    "min": "0",
                    "step": ".01",
                    "label": "Peso",
                    "options": {
                        "lb": "Lbs",
                        "kg": "Kg",
                    },
                    "defaultOption": "lb"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "vweigth",
                    "dynamicType": "number",
                    "min": "0",
                    "step": ".01",
                    "label": "Peso Volumentrico",
                    "options": {
                        "ft³": "ft³",
                        "vlb": "Vlb",
                    },
                    "defaultOption": "ft³"
                },
            ],
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "tipo_transporte",
                    "label": "Tipo Transporte",
                    "options": {
                        "air": "Aereo",
                        "sea": "Maritimo",
                    },
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": JSON_TABLE_INPUT_TYPE,
                    "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                    "dataSchema": {
                        "cant": {
                            "label": "Cant",
                            "type": "number",
                            "min": "0",
                            "headingWidth": "col-2",
                        },
                        "description": {
                            "label": "Description",
                            "type": "text",
                            "min": "0",
                            "headingWidth": "col-7",
                        },
                        "price": {
                            "label": "Precio",
                            "type": "money",
                            "step": ".01",
                            "isDecimal": true,
                            "headingWidth": "col-3",
                        }
                    },
                    "name": "commotity",
                    "legend": "Contenido de Paquete (commotity)"
                },
            ]
        ]
    }]
};

export default form;